import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "@/services/firebaseService";
import { handleFirebaseError } from "@/utils/errorUtils";

export type UnsplashPhotoResult = {
  id: string;
  thumbUrl: string;
  smallUrl: string;
  fullUrl: string;
  photoPageUrl: string;
  photographerName: string;
  photographerProfileUrl: string;
  downloadLocation: string;
};

export type UnsplashQuotaSnapshot = {
  poolRemainingApprox: number | null;
  poolLimitApprox: number | null;
  nextResetAtMs: number | null;
  updatedAtMs: number | null;
  keysCount: number;
};

export type SearchUnsplashPhotosResponse = {
  results: UnsplashPhotoResult[];
  quota: UnsplashQuotaSnapshot;
  usedCalls: number;
  limitedQueries?: number;
};

function getRegionalFunctions() {
  // IMPORTANT: this must be lazy for test environments that import UI components
  // but do not initialize Firebase Functions.
  return getFunctions(app, "us-east4");
}

export async function getUnsplashQuotaStatus(): Promise<UnsplashQuotaSnapshot> {
  try {
    const fn = httpsCallable<Record<string, never>, UnsplashQuotaSnapshot>(getRegionalFunctions(), "getUnsplashQuotaStatus");
    const res = await fn({});
    return res.data;
  } catch (e: any) {
    throw new Error(handleFirebaseError(e));
  }
}

export async function searchUnsplashPhotos(input: { queries: string[]; maxResults?: number }): Promise<SearchUnsplashPhotosResponse> {
  try {
    const fn = httpsCallable<{ queries: string[]; maxResults?: number }, SearchUnsplashPhotosResponse>(
      getRegionalFunctions(),
      "searchUnsplashPhotos"
    );
    const res = await fn(input);
    return res.data;
  } catch (e: any) {
    throw new Error(handleFirebaseError(e));
  }
}

export async function trackUnsplashDownload(input: { downloadLocation: string }): Promise<{ ok: true; quota: UnsplashQuotaSnapshot }> {
  try {
    const fn = httpsCallable<{ downloadLocation: string }, { ok: true; quota: UnsplashQuotaSnapshot }>(
      getRegionalFunctions(),
      "trackUnsplashDownload"
    );
    const res = await fn(input);
    return res.data;
  } catch (e: any) {
    throw new Error(handleFirebaseError(e));
  }
}

